import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    '& .MuiPaper-root': {
      minWidth: 250,
    },
  },
  title: {
    position: 'relative',
    marginBottom: theme.spacing(1.5),
  },
  closeIcon: {
    top: '50%',
    cursor: 'pointer',
    position: 'absolute',
    right: theme.spacing(2),
    transform: 'translateY(-50%)',
    '&.material-icons': {
      fontSize: theme.typography.pxToRem(24),
    },
  },
  text: {
    '&, & *': {
      lineHeight: '1.1 !important',
    },
  },
  definition: {
    ...theme.typography.h4,
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: '100%',
      aspectRatio: 16 / 9,
      objectFit: 'contain',
    },
  },
  actionsContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    flexDirection: 'column',
  },
  actions: {
    width: '100%',
  },
  actionAgree: {},
  actionDecline: {},
  actionClose: {},
}))
